import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { RouterModule, Routes, Router, ActivatedRoute, Params } from '@angular/router';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HpService } from 'projects/hp-api/src/lib/services/hp.service';
import { WizardHpBaseComponent } from '../base/wizard/wizard-hp-base-component';

@Component({
  selector: 'app-modal-info',
  templateUrl: './modal-info.component.html',
  styleUrls: ['./modal-info.component.scss']
})
export class ModalInfoComponent implements OnInit {
  message_erreur:any;
  constructor(private chgDetectorRef: ChangeDetectorRef,private hpService: HpService, @Inject(MAT_DIALOG_DATA) public data: any, 
  public dialogRef: MatDialogRef<ModalInfoComponent>) {
    this.message_erreur = this.hpService.getConfig().content_page.simulateur.message_erreur;
  }

  ngOnInit() {
    console.log(this.hpService.getConfig().content_page.simulateur.message_erreur);
   

  }

  getConfig(){

    return this.hpService.getConfig().content_page.simulateur.message_erreur;
  }

  closeModal() {
    this.dialogRef.close();
    this.hpService.setModalInfoOpened(false);
    this.hpService.emitDataChange();
    this.hpService.emitDataChange();
    this.chgDetectorRef.detectChanges();
  }

}
